import { useFlexFlagIsOn } from '@indeed/flex-feature-flags'
import React from 'react'
import CellTag from 'syft-acp-uikit/components/AcpTable/cellComponents/CellTag/CellTag'

const BackupWorkerTag = ({ isDemandBuffer }: { isDemandBuffer: boolean | undefined }) => {
  const isBackupTagEnabled = useFlexFlagIsOn('stsmpd_687_backup_worker')

  if (!isBackupTagEnabled || !isDemandBuffer) return null
  return <CellTag value="Backup worker" slug="backup-worker" color="gray-light" />
}

export { BackupWorkerTag }
